module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_8003.5d27d522.png";